import logger from '@src/utils/logger.ts';
import React, { useEffect } from 'react';

const GoogleAnalytics: React.FC = () => {
  useEffect(() => {
    const env = import.meta.env.VITE_APP_ENV;

    if (!['staging', 'production'].includes(env)) {
      logger.log('Google Analytics and GTM are disabled in this environment');
      return;
    }

    const gtmId = import.meta.env.VITE_GTM_ID;
    const ga4Id = import.meta.env.VITE_GA4_ID;
    // TODO... User IDの取得
    const uid = localStorage.getItem('uid') || 'anonymous_user';

    if (!gtmId || !ga4Id) {
      logger.warn('GTM or GA4 ID is not defined in the environment variables');
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'user_init',
      uid,
    });

    // Insert Google Tag Manager script
    const gtmScript = document.createElement('script');
    gtmScript.textContent = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(gtmScript);

    // Insert Google Analytics GA4 script
    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
    document.head.appendChild(gaScript);

    const gaInitScript = document.createElement('script');
    gaInitScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${ga4Id}', {
        'user_id': '${uid}'
      });
    `;
    document.head.appendChild(gaInitScript);
  }, []);

  return (
    <>
      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${import.meta.env.VITE_GTM_ID}`}
          height='0'
          width='0'
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
      {/* End Google Tag Manager (noscript) */}
    </>
  );
};

export default GoogleAnalytics;
